/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdminReservedSurveyMarkNumbersDto } from '../../models/admin-reserved-survey-mark-numbers-dto';

export interface AdminGetReservedSurveyMarkNumbers$Params {
  user_id?: string;
  mark_name?: string;
}

export function adminGetReservedSurveyMarkNumbers(
  http: HttpClient,
  rootUrl: string,
  params?: AdminGetReservedSurveyMarkNumbers$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AdminReservedSurveyMarkNumbersDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    adminGetReservedSurveyMarkNumbers.PATH,
    'get',
  );
  if (params) {
    rb.query('user_id', params.user_id, {});
    rb.query('mark_name', params.mark_name, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AdminReservedSurveyMarkNumbersDto>;
      }),
    );
}

adminGetReservedSurveyMarkNumbers.PATH = '/admin/surveyMarks/reserved';
